<template>
	<div>
		<template v-if="size==='small'">
			<div>
				<a-tooltip
					v-if="value.Email"
					placement="top"
				>
					<template slot="title">
						Enviado
					</template>

					<fa-icon
						:icon="['far', 'envelope']"
						class="mr-2 text-primary"
					/>
				</a-tooltip>
				<a-tooltip
					v-else
					placement="top"
				>
					<template slot="title">
						No Enviado
					</template>
					<fa-icon

						:icon="['far', 'envelope']"
						class="mr-2 text-muted"
					/>
				</a-tooltip>

				<a-tooltip
					v-if="value.Email && value.Email.Abierto"
					placement="top"
				>
					<template slot="title">
						Leido
					</template>

					<fa-icon
						:icon="['far', 'eye']"
						class="mr-2 text-primary"
					/>
				</a-tooltip>
				<a-tooltip
					v-else
					placement="top"
				>
					<template slot="title">
						No leido
					</template>
					<fa-icon

						:icon="['far', 'eye']"
						class="mr-2 text-muted"
					/>
				</a-tooltip>

				<a-tooltip
					v-if="value.Email && value.Email.Leido"
					placement="top"
				>
					<template slot="title">
						Abierto
					</template>

					<fa-icon
						:icon="['far', 'folder-open']"
						class="mr-2 text-primary"
					/>
				</a-tooltip>
				<a-tooltip
					v-else
					placement="top"
				>
					<template slot="title">
						No abierto
					</template>
					<fa-icon

						:icon="['far', 'folder-open']"
						class="mr-2 text-muted"
					/>
				</a-tooltip>
			</div>
		</template>
		<template v-else>
			<a-tag
				v-if="value.Email"
				:color="value.Email.Abierto ? $colors.primary : ''"
			>
				<a-tooltip placement="top">
					<template slot="title">
						<span v-if="value.Email.Abierto">
							<fa-icon
								:icon="['fa', 'check-double']"
								class="mr-2"
							/>Abierto
						</span>
						<span v-else-if="value.Email.Leido">
							<fa-icon
								:icon="['fa', 'check']"
								class="mr-2"
							/>Leido
						</span>
						<span v-else>
							<fa-icon
								:icon="['fa', 'envelope-open-text']"
								class="mr-2"
							/>Enviado
						</span>
					</template>

					<fa-icon
						v-if="value.Email.Abierto"
						:icon="['fa', 'check-double']"
						class="mr-2 text-success"
					/>
					<fa-icon
						v-else-if="value.Email.Leido"
						:icon="['fa', 'check']"
						class="mr-2 text-success"
					/>
					<fa-icon
						v-else
						:icon="['fa', 'envelope-open-text']"
						class="mr-2 text-primary"
					/>
				</a-tooltip>

				<a-tooltip placement="top">
					<template slot="title">
						{{ value.Email.Fecha | moment("LLL") }}
					</template>
					{{ value.Email.Fecha | moment("DD-MM-YYYY") }}
				</a-tooltip>
			</a-tag>
			<a-tag
				v-else
				size="small"
				:style="
					`color: ${$colors['gray-6']};
				border: 1px dashed ${$colors['gray-6']};
				background: transparent`
				"
			>
				<fa-icon
					:icon="['far', 'clock']"
					class="mr-2"
				/> No enviado
			</a-tag>
		</template>
	</div>
</template>

<script>
export default {
	name: 'GEmail',
	props: {
		value: {
			type: Object,
			required: true
		},
		size: {
			type: String,
			default: 'default'
		}
	}
};
</script>

<style lang="scss" module>

</style>
